export default {
  //URL_CONFIG: "/config/index.json",
  URL_CONFIG: "https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/aeea2020/config/index.json",
  BITMOVIN_ANALYTICS_KEY: "ade734cd-842a-4308-b630-9d3c3b709ce0",
  MUX_ANALYTICS_KEY: "g390j6uqqi612ienbuk94q10h",
  MUX_PROPERTY_ID: "AEEA",
  S3_REGION: "ap-southeast-2",
  S3_BUCKET: "events-public-assets",
  COGNITO_REGION: "ap-southeast-2",
  COGNITO_USER_POOL_ID: "ap-southeast-2_puPL2D7rD",
  COGNITO_APP_CLIENT_ID: "165dvgdc6obdo0o8i4cbbid4v7",
  COGNITO_IDENTITY_POOL_ID: "ap-southeast-2:d7480839-6b67-4528-aff6-417bb770e279",
  BACKEND_REGION: "ap-southeast-2",
  BACKEND_API_NAME: "backend-api",
  ZENDESK_API_TOKEN: "42pzgqiuUL6qTOtljOIJWcELj2lJN3qA9ADBL9Ig"
}